import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Buefy from "buefy";
import i18n from "./i18n";
import { truncate } from "lodash";
import PortalVue from "portal-vue";
import VueScrollTo from "vue-scrollto";
import VueSheperd from "vue-shepherd";
import LoadingComponent from "./components/LoadingComponent";

Vue.use(Buefy);
Vue.use(PortalVue);
Vue.use(VueScrollTo);
Vue.use(VueSheperd);

Vue.component("loading-component", LoadingComponent);

/*
 |--------------------------------------------------------------------------
 | Directives
 |--------------------------------------------------------------------------
 */

Vue.directive("loading", {
	inserted (el, binding) {
		let loadingMask = document.createElement("div");
		loadingMask.className = "loading-mask";
		el.appendChild(loadingMask);
		if (binding.value) {
			loadingMask.className += " is-active";
		}
	},
	update (el, binding) {
		let loadingMask = el.getElementsByClassName("loading-mask")[el.getElementsByClassName("loading-mask").length - 1]; // Get the last div in the node
		if (binding.value) {
			loadingMask.className += " is-active";
		} else {
			loadingMask.className = "loading-mask";
		}
	}
});

/*
 |--------------------------------------------------------------------------
 | Prototypes
 |--------------------------------------------------------------------------
 */

Vue.prototype.$truncate = truncate;

/*
 |--------------------------------------------------------------------------
 | Instance
 |--------------------------------------------------------------------------
 */

new Vue({
	router,
	store,
	i18n,
	render: h => h(App)
}).$mount("#app");
